import { FormField } from "~/components/ui/form-field";
import { RichTextEditor } from "~/components/ui/rich-text-editor";

import { useFieldContext } from "./field-context";
import { useFieldError } from "./field-errors";

export function RichTextField({
  label,
  placeholder,
  required,
  helpText,
  maxLength,
}: {
  label?: string;
  placeholder?: string;
  required?: boolean;
  helpText?: string;
  maxLength?: number;
}) {
  const field = useFieldContext<string | null | undefined>();
  const error = useFieldError(field.name);
  return (
    <FormField
      label={label}
      required={required}
      helpText={helpText}
      error={error}
    >
      <RichTextEditor
        content={field.state.value ?? ""}
        onChange={field.handleChange}
        placeholder={placeholder}
        maxLength={maxLength}
        className="min-h-[180px]"
      />
    </FormField>
  );
}
